import React from "react";
import VisibleToExternalIcon from "../../components/VisibleToExternal/VisibleToExternalIcon";
import { PhosphorPencilButton, PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";

interface Props {
  file: server.dto.File
  onEdit: (file: server.dto.File) => void
  onDelete: (file: server.dto.File) => void

  config: server.dto.LinkedFilePanelConfig
}

const FileRow = (props: Props) => {
  const { file, onEdit, onDelete, config } = props;

  return <div>
    <div className="grow1 flex-column gap-small">
      <div><a href={file.downloadUrl} download="">{file.fullName}</a></div>
      <div className="text-sublabel">{`${RESX.File.UploadedBy} ${file.uploadBy} ${file.uploadOnText}`}</div>
    </div>

    <div>
      <div>{file.contentLengthText}</div>
    </div>

    {config.displayVisibleToExternalIcon && <div>
      <VisibleToExternalIcon visibleToExternal={file.visibleToExternal} />
    </div>}

    {file.permissions.canDelete && <PhosphorTrashButton
      layout="in-square"
      onClick={() => { onDelete(file); }}
    />}

    {file.permissions.canModify && <PhosphorPencilButton
      layout="in-square"
      onClick={() => { onEdit(file); }}
    />}
  </div>;
};

export default FileRow;